<template>
  <div v-loading="loadingTrip">
    <main-farme>
      <!-- --------------------------------------------左边栏-------------------------------------------- -->
      <div v-show="showTravelPlanEditor"
           slot="aside-left">
        <travel-plan-editor ref="travel_plan_editor"
                            @selectBeginDate="selectBeginDate"
                            @addResidence="addResidence"
                            @addTraverPoint="addTraverPoint"
                            @openTrafficEditor="openTrafficEditor"
                            @activateEditorDay="activateEditorDay"
                            @deleteTraverPointFromDayTrip="deleteTraverPointFromDayTrip"
                            @editTraverPointFromDayTrip="editTraverPointFromDayTrip"
                            @creatNewDayTrip="creatNewDayTrip"
                            @saveTravelPlan="reviewTravelPlan"
                            :editorDayIndex="editorDayIndex"
                            @addOneDayToTravelPlan="addOneDayToTravelPlan"
                            :planItemList="planItemList"></travel-plan-editor>
      </div>
      <!-- --------------------------------------------方案添加-------------------------------------------- -->
      <div slot="main">
        <el-dialog title="需求单"
                   @open="getDataOfRequire"
                   :visible.sync="dialogRequireVisible">
          <el-table :data="requireData"
                    @cell-click="clickOneRequire">
            <el-table-column property="start_date"
                             label="出发日期"
                             width="100"></el-table-column>
            <el-table-column property="contact"
                             label="姓名"
                             width="100"></el-table-column>
            <el-table-column property="status_name"
                             label="目的地"></el-table-column>
            <el-table-column property="dest_name"
                             label="状态"></el-table-column>
          </el-table>
        </el-dialog>

        <!-- 配置 -->
        <el-card shadow="nerver"
                 :body-style="{ padding: '20px 20px 5px 20px'}"
                 style="margin-bottom:10px">
          <!-- 无出行需求 -->
          <div v-if="JSON.stringify(require_info) == '{}'">
            <el-button @click="openSelectRequire"
                       type="primary"
                       size="mini">选择需求单</el-button>

          </div>
          <!-- 绑定需求后 -->
          <div v-else>
            <div v-if="showRequire">
              <div>
                <el-button type="primary"
                           style="margin-right:10px"
                           @click="openSelectRequire"
                           size="mini">更换</el-button>
                <span class="require-info-item">联系人：{{require_info.contact}}</span>
                <span class="require-info-item">电话：{{require_info.mobile}}</span>
                <span class="require-info-item">微信：{{require_info.wechat}}</span>
                <span class="require-info-item"> 来源：{{require_info.source_name}}</span>
              </div>
              <divider-line> </divider-line>
              <div>
                <span class="require-info-item"> 需求单ID：{{require_info.id}}</span>
                <span class="require-info-item"> 游玩目的地：{{require_info.dest_name}}</span>
                <span class="require-info-item"> 当前行程状态：{{require_info.status_name}}</span>
                <span class="require-info-item"> 出游人群：{{require_info.trip_people_type_name}}</span>
              </div>
              <divider-line> </divider-line>
              <!-- 出发日期 -->
              <div>
                <!-- 已确定出发日期，为预定机票 -->
                <span v-if="require_info.trip_date_type==0">
                  已确定出发日期，为预定机票：

                  <span class="require-info-item">出发日期：{{require_info.start_date}}</span>
                  <span class="require-info-item">结束日期：{{require_info.end_date}}</span>

                </span>
                <!-- 已预定机票 -->
                <span v-if="require_info.trip_date_type==1">
                  <div>已预定机票： <span class="require-info-item">行程订单截图：{{require_info.traffic_booking}}</span></div>

                </span>
                <!-- 未确定出发日期 -->
                <span v-if="require_info.trip_date_type==2">未确定出发日期：</span>
                <span v-if="require_info.trip_date_type==3"
                      class="require-info-item">大概出发日期：{{require_info.about_date}}</span>
              </div>
              <divider-line> </divider-line>
              <div>
                <span>需求：<div v-html="require_info.requirement_text"></div> </span>
                <span class="require-info-item">图片需求：</span>
              </div>
              <div>
                <span>可以接受的出行模式：
                  <span v-if="require_info.travel_mode_explore">可探索</span>
                  <span v-if="require_info.travel_mode_driving">可租车/自驾</span>
                  <span v-if="require_info.travel_mode_tour">可拼团</span>
                </span>
              </div>
            </div>
            <div v-if="!showRequire">
              <span class="require-info-item">联系人：{{require_info.contact}}</span>
              <span class="require-info-item">电话：{{require_info.mobile}}</span>
              <span class="require-info-item">微信：{{require_info.wechat}}</span>
              <span class="require-info-item"> 来源：{{require_info.source_name}}</span>
            </div>
            <div size="mini"
                 style="width:100%;color:#ff5421;cursor:pointer;text-align:center"
                 @click='showRequire=!showRequire'>

              ▾显示/收起 需求单
            </div>
          </div>
        </el-card>
        <!-- 编辑方案 -->
        <el-tabs v-model="selectTab"
                 @tab-click="clickTab"
                 type="border-card">
          <el-tab-pane name="first">
            <span slot="label"><i class="el-icon-date"></i> 方案概况</span>
            <travel-plan-table :starDate="starDate"
                               @bandTravelPlanToRequire="bandTravelPlanToRequire"
                               :tableDate="planItemList"></travel-plan-table>
          </el-tab-pane>
          <el-tab-pane name="second">
            <span slot="label"><i class="el-icon-s-flag"></i> 选日行程</span>
            <select-day-trip-list ref="select_day_trip_list"
                                  :dayTripListLoadeing="dayTripListLoadeing"
                                  @getDayTripDate="getDayTripDateFromDayTripList"></select-day-trip-list>
          </el-tab-pane>
          <el-tab-pane name="third">
            <span slot="label"><i class="el-icon-location"></i>找迹点</span>
            <select-traver-point-list @addTraverToDayTrip="addTraverToDayTrip"></select-traver-point-list>
          </el-tab-pane>
          <el-tab-pane name="fourth">
            <span slot="label"><i class="el-icon-school"></i> 找酒店</span>
            <select-residence-list @addResidenceToDayTrip="addResidenceToDayTrip"></select-residence-list>
          </el-tab-pane>
          <!-- :lazy="true" 延迟加载！！！！！！！ -->
          <el-tab-pane :lazy="true"
                       name="fifth">
            <span slot="label"><i class="el-icon-position"></i> 找交通</span>
            <travel-plan-traffic-editor ref="travel_plan_traffic_editor"
                                        @addTrafficPlanToTraverPoint="addTrafficPlanToTraverPoint"
                                        :TraverOrResidenceBetween="TraverOrResidenceBetween"></travel-plan-traffic-editor>
          </el-tab-pane>
          <el-tab-pane :lazy="true"
                       name="sixth">
            <span slot="label"><i class="el-icon-discover"></i> 编辑迹点</span>
            <traver-detial-change :edit_item_content="edit_item_content"></traver-detial-change>
          </el-tab-pane>

        </el-tabs>
        <!-- 行程预览 对话框/弹出 预览 -->
        <el-dialog title="扫码预览"
                   :visible.sync="showTripPlanReviewCode"
                   @close="closeDeleteTrip"
                   width="30%">
          <span>
            <vue-qr :margin="15"
                    colorDark="#FF5421"
                    colorLight="#FFF"
                    :logoSrc="qrImageUrl"
                    :text="JSON.stringify({'code':this.reviewCode,'type':'tripPlanReview'}) "
                    :size="300"></vue-qr>
          </span>
          <!-- <span slot="footer"
                class="dialog-footer">
            <el-button type="primary"
                       @click="closeTripPlanReviewCode">关闭预览</el-button>
          </span> -->
        </el-dialog>
      </div>

      <!-- --------------------------------------------右侧边栏-------------------------------------------- -->
      <div slot="aside-right">
      </div>
    </main-farme>
  </div>
</template>

<script>
import MainFrame from '../../components/common/main/MainFrame'
//编辑方案的组件
import TravelPlanEditor from '../../components/traver/TravelPlanEditor'
import SelectDayTripList from '../../components/traver/SelectDayTripList'
import SelectResidenceList from '../../components/traver/SelectResidenceList'
// 主要区域的内容
import SelectTraverPointList from '../../components/traver/SelectTraverList'
import TravelPlanTable from '../../components/traver/TravelPlanTable'
import TravelPlanTrafficEditor from '../../components/traver/TravelPlanTrafficEditor'
import TraverDetialChange from '../../components/traver/TraverDetialChange'
import vueQr from 'vue-qr'

//
import DividerLine from '../../components/common/other/DividerLine'
export default {
  name: 'creat_travel_plan',
  components: {
    'main-farme': MainFrame,
    TravelPlanEditor,
    SelectDayTripList,
    TravelPlanTable,
    SelectTraverPointList,
    SelectResidenceList,
    TravelPlanTrafficEditor,
    TraverDetialChange,
    DividerLine,
    vueQr,
  },
  data() {
    return {
      loadingTrip: false,
      require_id: null,
      trip_id: null,
      require_info: {},
      showRequire: false,
      selectTab: 'second',
      showTravelPlanEditor: true,
      // 需求单
      dialogRequireVisible: false,
      requireData: [],
      contact: '',
      mobile: '',
      source: '',
      status: '',
      start_date: '',
      dest: '',
      // tripDateRange: ['2021-04-05', '2021-04-06'],
      tripDateRange: [],
      tabPosition: 'left',
      //
      // 当前编辑行程日：
      editorDayIndex: 0,
      dayTripListLoadeing: false, //
      // 添加迹点用
      addTraverPointTripType: null,
      addTraverPointIndex: null,
      // 添加酒店用
      addResidenceTripType: null,
      addResidenceIndex: null,
      // 添加交通方案用
      addTrafficPlanTripType: null,
      addTrafficPlanIndex: null,
      // 调整迹点
      edit_item_content: null,
      // 方案数据格式
      starDate: new Date(),
      planItemList: [],
      tableList: [], // 表格数据，将说明字段 添加到日行程

      // 添加交通时，编辑页显示两点间的名字
      TraverOrResidenceBetween: [],
      // 方案预览
      showTripPlanReviewCode: false,
      reviewCode: '',
      reviewPlanId: null,
      qrImageUrl: require('../../assets/img/TRAVER-logo.jpg'),
    }
  },
  watch: {
    planItemList: {
      handler(newValue) {
        this.planItemList = newValue
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    console.log('路由', this.$route.query)
    this.require_id = this.$route.query.require_id
    this.trip_id = this.$route.query.trip_id
    this.loadingTrip = true
    this.getRequirementInfo(this.require_id)
    this.getTravelPlan(this.trip_id)
  },
  methods: {
    getTravelPlan(trip_id) {
      this.$http
        .get(`/traver/get_trip_plan_requirement?trip_id=${trip_id}`)
        .then((res) => {
          if (res.data.errno == '0') {
            this.planItemList = res.data.data
            // 行程数据
            console.log('行程数据', this.planItemList)
            // console.log(res.data.start_date)
            this.starDate = new Date(res.data.start_date)
            this.$refs.travel_plan_editor.selectBeginDate = new Date(
              res.data.start_date
            )
            this.loadingTrip = false
          }
        })
    },
    getRequirementInfo(require_id) {
      this.$http
        .get(`/traver/get_require_information?require_id=${require_id}`)
        .then((res) => {
          if (res.data.errno == '0') {
            this.require_info = res.data.data
            // console.log(this.require_info.contact)
          }
        })
    },
    reviewTravelPlan() {
      this.selectTab = 'first'
      this.loadingTrip = true
      // 保存方案名称为预览方案
      let postItem = {
        require_id: this.require_id,
        start_date: this.starDate.toLocaleDateString(),
        trip_plan: this.planItemList,
        plan_name: '预览方案rq_id' + this.require_id,
      }
      // console.log(postItem)
      this.$http
        .post('/traver/band_requirement_and_trip_plan', postItem)
        .then((res) => {
          // console.log(res)
          if (res.data.errno == '0') {
            // 关闭家在动画
            this.loadingTrip = false
            // 返回 code
            this.reviewCode = res.data.code
            this.reviewPlanId = res.data.plan_id

            // 打开对话框，显示二维码
            this.showTripPlanReviewCode = true

            // 如果关闭则删除行程
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
      // 生成二维码
      // 关闭后，删除方案
    },
    // 关闭预览
    closeDeleteTrip() {
      // 执行删除
      this.$http
        .get(`/traver/delete_trip_plan?trip_plan_id=${this.reviewPlanId}`)
        .then((res) => {
          if (res.data.errno == '0') {
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },

    // 绑定方案给 需求
    bandTravelPlanToRequire() {
      // 转换数据
      // let year = this.starDate.getFullYear()
      // let month = this.starDate.getMonth() + 1
      // let date = this.starDate.getDate()
      // 整理数据
      let postItem = {
        require_id: this.require_id,
        start_date: this.starDate.toLocaleDateString(),
        trip_plan: this.planItemList,
      }
      // 当前日期时间

      var datetime = new Date()
      var year = datetime.getFullYear()
      var month =
        datetime.getMonth() + 1 < 10
          ? '0' + (datetime.getMonth() + 1)
          : datetime.getMonth() + 1
      var date =
        datetime.getDate() < 10 ? '0' + datetime.getDate() : datetime.getDate()
      var hours =
        datetime.getHours() < 10
          ? '0' + datetime.getHours()
          : datetime.getHours()
      var minutes =
        datetime.getMinutes() < 10
          ? '0' + datetime.getMinutes()
          : datetime.getMinutes()
      var seconds =
        datetime.getSeconds() < 10
          ? '0' + datetime.getSeconds()
          : datetime.getSeconds()

      // console.log(postItem)
      // return
      // 填写 travel——plan——name
      this.$prompt(
        '请【核对日期后】输入方案名称（格式为：联系+方案版号+备注内容）:',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValue:
            year +
            '/' +
            month +
            '/' +
            date +
            ' ' +
            hours +
            ':' +
            minutes +
            ':' +
            seconds,
        }
      )
        .then(({ value }) => {
          postItem.plan_name = value
          // console.log(postItem)
          this.$http
            .post('/traver/band_requirement_and_trip_plan', postItem)
            .then((res) => {
              // console.log(res)
              if (res.data.errno == '0') {
                this.$message({
                  message: res.data.errmsg,
                  type: 'success',
                })
              } else {
                this.$message({
                  message: res.data.errmsg,
                  type: 'error',
                })
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '取消生成方案',
          })
        })
    },
    // 切换
    clickTab() {
      if (this.selectTab == 'first') {
        // this.showTravelPlanEditor = false
      } else if (this.selectTab == 'fifth') {
        this.$refs.travel_plan_traffic_editor
      } else if (this.selectTab == 'second') {
        this.$refs.select_day_trip_list.getDayTripList()
      }
    },
    // 行程开始日期
    selectBeginDate(date) {
      // console.log(date)
      this.starDate = date
    },
    // 当前在编辑的 行程
    activateEditorDay(day_index) {
      // console.log(day_index)
      // 确定当前编辑的行程日
      this.editorDayIndex = day_index
      // 将其他辅助编辑的信息 初始化
      this.addTraverPointTripType = null
      this.addTraverPointIndex = null
      // 添加酒店用
      this.addResidenceTripType = null
      this.addResidenceIndex = null
      // 添加交通方案用
      this.addTrafficPlanTripType = null
      this.addTrafficPlanIndex = null
    },
    // 添加日行程 到方案中
    getDayTripDateFromDayTripList(trip_id) {
      // console.log(day_trip_id)
      if (this.planItemList.length == 0) {
        this.$message({
          message: '请先添加日行程',
          type: 'error',
        })
        return
      }
      this.dayTripListLoadeing = true

      // 获取日行程数据
      this.$http
        .get(`/traver/get_day_trip_info?trip_id=${trip_id}`)
        .then((res) => {
          // this.editorDayIndex  当前编辑的ID
          if (res.data.errno == '0') {
            // console.log('获取需要添加的日行程', res)
            // 循环，找到index
            this.planItemList.forEach((item) => {
              if (this.planItemList.indexOf(item) == this.editorDayIndex) {
                // 注释
                // console.log(
                //   '添加到第几天',
                //   this.planItemList.indexOf(item) + 1,
                //   '天'
                // )
                // console.log(item)
                // 2 抵达  1 整日 3离开
                if (res.data.dayTrip.trip_type == 1) {
                  item.arrivalTrip.dayTripInfo = res.data.dayTrip
                  item.arrivalTrip.dayTripTraverList = res.data.traverList
                } else if (res.data.dayTrip.trip_type == 2) {
                  item.allDayTrip.dayTripInfo = res.data.dayTrip
                  item.allDayTrip.dayTripTraverList = res.data.traverList
                } else if (res.data.dayTrip.trip_type == 3) {
                  item.departureTrip.dayTripInfo = res.data.dayTrip
                  item.departureTrip.dayTripTraverList = res.data.traverList
                } else if (res.data.dayTrip.trip_type == 4) {
                  item.transitTrip.dayTripInfo = res.data.dayTrip
                  item.transitTrip.dayTripTraverList = res.data.traverList
                }
              }
            })
            this.dayTripListLoadeing = false
            // 添加到当前编辑的行程日
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    // 添加一天 给列表
    addOneDayToTravelPlan(newDayTripList) {
      this.selectTab = 'second'
      // console.log('addOneDayToTravelPlan-增加后总天数：', this.planItemList)
    },
    // 【添加迹点】给日行程添加迹点
    addTraverPoint(tripType, index) {
      this.addTraverPointTripType = tripType
      this.addTraverPointIndex = index
      this.selectTab = 'third'
    },
    // 【添加酒店】给日行程添加酒店
    addResidence(tripType, index) {
      this.addResidenceTripType = tripType
      this.addResidenceIndex = index
      this.selectTab = 'fourth'
    },
    // 获取 迹点内容
    editTraverPointFromDayTrip(tripType, index, item_index) {
      // console.log('dian', tripType, index, item_index)
      const edit_item =
        this.planItemList[index][tripType].dayTripTraverList[item_index]
      console.log(edit_item)
      // 跳转内容框
      this.edit_item_content = edit_item
      this.selectTab = 'sixth'
    },
    // 从方案的日行程删除 点
    deleteTraverPointFromDayTrip(tripType, index, item_index) {
      // console.log('dian', tripType, index, item_index)
      this.planItemList[index][tripType].dayTripTraverList.splice(item_index, 1)
      // console.log(this.planItemList[index][tripType].dayTripTraverList)
    },
    // 【添加交通方案】
    openTrafficEditor(tripType, traver_index, item, next_item, day_index) {
      // console.log('日行类型', tripType)
      console.log('第', traver_index, '几个迹点')
      console.log('2个迹点内容', item, next_item)
      console.log('第几天', this.editorDayIndex)
      console.log('第几天的行程内容', this.planItemList[this.editorDayIndex])

      // 点击的那天日行程所包含的迹点
      let dayTrip =
        this.planItemList[this.editorDayIndex][tripType].dayTripTraverList

      // 给迹点数据添加traffic_id 字段和值
      this.$http
        .get(
          `/traver/match_traffic_two_poi?poi_list=${[
            item.poi_id,
            next_item.poi_id,
          ]}&traffic_class=1`
        )
        .then((res) => {
          console.log('匹配迹点', res)
          // 把traffic_id 添加到迹点中
          dayTrip.forEach((i) => {
            if (i.id == item.id) {
              i['traffic_id'] = res.data.data.traffic_id
            }
          })
        })
      new Promise((resolve, reject) => {
        this.selectTab = 'fifth'
        this.addTrafficPlanTripType = tripType
        this.addTrafficPlanIndex = traver_index
        resolve()
      }).then(() => {
        // 1.两点之间的名字，用于更新到交通组件
        //  获取 类型，
        if ('traver_title' in item) {
          this.TraverOrResidenceBetween = []
          this.TraverOrResidenceBetween.push(item.traver_title)
          this.TraverOrResidenceBetween.push(next_item.traver_title)
        } else if ('residence_name' in item) {
          this.TraverOrResidenceBetween = []
          this.TraverOrResidenceBetween.push(item.residence_name)
          this.TraverOrResidenceBetween.push(next_item.traver_title)
        }
        // 2. 绘制路线，和点标记
        this.$refs.travel_plan_traffic_editor.makePointAndRoute(
          item.poi_id,
          next_item.poi_id
        )
        //
      })
    },
    // 添加交通方案给迹点
    addTrafficPlanToTraverPoint(traffic_plan_list) {
      console.log('选择交通方案：', traffic_plan_list)
      // console.log('第几天', this.editorDayIndex)
      // console.log('日行程类型', this.addTrafficPlanTripType)
      console.log('第几个迹点/酒店', this.addTrafficPlanIndex)
      if (this.addTrafficPlanTripType == null) {
        this.$message({
          message: '请确认添加酒店的位置',
          type: 'error',
        })
        return
      }
      // let newPlanItemList = this.planItemList[this.editorDayIndex][
      //   this.addTrafficPlanTripType
      // ].dayTripTraverList[this.addTrafficPlanIndex]
      // console.log(newPlanItemList)
      // this.$set(newPlanItemList,'')
      // console.log('添加交通到，更新方案')
      this.planItemList.forEach((day_item) => {
        if (this.planItemList.indexOf(day_item) == this.editorDayIndex) {
          // 添加交通方案给迹点
          let traver_item =
            day_item[this.addTrafficPlanTripType].dayTripTraverList[
              this.addTrafficPlanIndex
            ]
          this.$set(traver_item, 'TrafficPlan', traffic_plan_list)
          // 添加traffic_dict 给迹点
          if (traffic_plan_list.length != 0) {
            this.$http
              .get(
                `/traver/get_traffic_info?traffic_id=${traffic_plan_list[0].traffic_id}`
              )
              .then((res) => {
                if ('traffic_dict' in traver_item) {
                  traver_item.traffic_dict = res.data.data
                } else {
                  this.$set(traver_item, 'traffic_dict', res.data.data)
                }
              })
          }
        }
      })
    },
    // 生成新的日行程 ---  更新方案日行程中的ID
    creatNewDayTrip(dayTrip_id, index, trip_type) {
      // 检查获取的数据
      // console.log('生成的', dayTrip_id, index, trip_type)
      // console.log('新日行程ID,顺序，日行程类型', dayTrip_id, index, trip_type)
      // 发送请求获取日行程数据
      // console.log(this.planItemList)
      // 获取日行程数据
      this.$http
        .get(`/traver/get_day_trip_info?trip_id=${dayTrip_id}`)
        .then((res) => {
          console.log(res)
          if (res.data.errno == '0') {
            // console.log('获取需要添加的日行程', res)
            // 循环，找到index
            this.planItemList[index][trip_type].dayTripInfo = res.data.dayTrip
            this.planItemList[index][trip_type].dayTripTraverList =
              res.data.traverList
            // 添加到当前编辑的行程日
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    // 添加迹点到日行程
    addTraverToDayTrip(traver_info) {
      if (this.addTraverPointIndex == null) {
        this.$message({
          message: '请确认添加迹点的位置',
          type: 'error',
        })
        return
      }
      // console.log(traver_info)
      let editorDayTrip =
        this.planItemList[this.editorDayIndex][this.addTraverPointTripType]
      editorDayTrip.dayTripTraverList.splice(
        this.addTraverPointIndex,
        0,
        traver_info
      )
    },
    // 添加酒店到日行程
    addResidenceToDayTrip(residence) {
      if (this.addResidenceTripType == null) {
        this.$message({
          message: '请确认添加酒店的位置',
          type: 'error',
        })
        return
      }
      //console.log('当前编辑的是第几天', this.editorDayIndex)
      //console.log('酒店内容', residence)
      // console.log('日行程中添加酒店的位置：', this.addResidenceIndex)
      // console.log('需要添加酒店的日行程类型', this.addResidenceTripType)
      //  console.log('编辑日数据', this.planItemList[this.editorDayIndex])
      let editorDayTrip =
        this.planItemList[this.editorDayIndex][this.addResidenceTripType]
      // console.log('编辑日 迹点列表', editorDayTrip.dayTripTraverList)
      editorDayTrip.dayTripTraverList.splice(
        this.addResidenceIndex,
        0,
        residence
      )
      // console.log('剪切添加后', editorDayTrip.dayTripTraverList)
    },
    // 打开选择需求 对话框
    openSelectRequire() {
      this.dialogRequireVisible = !this.dialogRequireVisible
    },
    getDataOfRequire() {
      this.$http
        .get(
          `/traver/get_requirement_form_list?contact=${this.contact}&mobile=${this.mobile}&source=${this.source}&status=${this.status}&start_date=${this.start_date}&dest=${this.dest}`
        )
        .then((res) => {
          console.log('获取需求单', res)
          if (res.data.errno == '0') {
            this.requireData = res.data.data
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    clickOneRequire(row) {
      // 需求单ID
      // console.log(row.id)
      this.getRequirementInfo(row.id)
      this.require_id = row.id
    },
  },
}
</script>

<style>
.trip_attritube_style {
  margin-bottom: 5px;
}
.traffit-between-traver-point {
  width: 300px;
}
.tab-way-map .el-tabs__content {
  padding: 0;
}
.require-info-item {
  margin-right: 10px;
}
</style>